import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiPhone, FiCreditCard, FiClock, FiUser, FiBook, FiLogOut, FiActivity, FiHelpCircle, FiMenu, FiX, FiRss } from 'react-icons/fi';
import logo from '../../assets/ringez.png';

const Navbar = ({ user, onLogout }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMenu = () => setMobileMenuOpen(!mobileMenuOpen);
    const closeMenu = () => setMobileMenuOpen(false);

    const navItems = [
        { to: '/call', icon: <FiPhone />, label: 'Call' },
        { to: '/wallet', icon: <FiCreditCard />, label: 'Wallet' },
        { to: '/history', icon: <FiClock />, label: 'History' },
        { to: '/contacts', icon: <FiBook />, label: 'Contacts' },
        { to: '/blog', icon: <FiRss />, label: 'Blog' },
        { to: '/support', icon: <FiHelpCircle />, label: 'Help' },
    ];

    return (
        <>
            <header className="header">
                {/* Logo */}
                <NavLink to="/" className="logo-section" style={{ textDecoration: 'none' }}>
                    <img
                        src={logo}
                        alt="Ringez"
                        style={{
                            height: '40px',
                            width: 'auto',
                            objectFit: 'contain'
                        }}
                    />
                </NavLink>

                {/* Desktop Navigation */}
                <nav className="nav-links desktop-nav">
                    {navItems.map(item => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
                        >
                            {item.icon} {item.label}
                        </NavLink>
                    ))}
                </nav>

                {/* Desktop Actions */}
                <div className="header-actions desktop-nav">
                    {user && !user.isGuest ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                            {user.role === 'admin' && (
                                <NavLink to="/admin" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
                                    <FiActivity /> Admin
                                </NavLink>
                            )}
                            <NavLink to="/profile" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
                                <FiUser /> Profile
                            </NavLink>
                            <button
                                onClick={onLogout}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    background: 'rgba(239, 68, 68, 0.1)',
                                    border: 'none',
                                    color: 'var(--danger)',
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0.5rem',
                                    fontSize: '1rem'
                                }}
                            >
                                <FiLogOut /> Logout
                            </button>
                        </div>
                    ) : (
                        <NavLink
                            to="/login"
                            style={{
                                textDecoration: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '1rem',
                                background: 'var(--primary)',
                                color: 'white',
                                padding: '0.6rem 1.25rem',
                                borderRadius: '0.5rem',
                                fontWeight: 600
                            }}
                        >
                            <FiUser /> Sign In
                        </NavLink>
                    )}
                </div>

                {/* Mobile Hamburger Button */}
                <button
                    className="mobile-menu-btn"
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                >
                    {mobileMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
                </button>
            </header>

            {/* Mobile Menu Overlay */}
            {mobileMenuOpen && (
                <div className="mobile-menu-overlay" onClick={closeMenu}>
                    <nav className="mobile-menu" onClick={e => e.stopPropagation()}>
                        <div className="mobile-menu-header">
                            <img src={logo} alt="Ringez" style={{ height: '36px' }} />
                            <button onClick={closeMenu} style={{ background: 'none', border: 'none', color: 'var(--text-main)', cursor: 'pointer' }}>
                                <FiX size={28} />
                            </button>
                        </div>

                        <div className="mobile-menu-links">
                            {navItems.map(item => (
                                <NavLink
                                    key={item.to}
                                    to={item.to}
                                    className={({ isActive }) => isActive ? 'mobile-nav-item active' : 'mobile-nav-item'}
                                    onClick={closeMenu}
                                >
                                    {item.icon} {item.label}
                                </NavLink>
                            ))}

                            {user && !user.isGuest ? (
                                <>
                                    {user.role === 'admin' && (
                                        <NavLink to="/admin" className="mobile-nav-item" onClick={closeMenu}>
                                            <FiActivity /> Admin
                                        </NavLink>
                                    )}
                                    <NavLink to="/profile" className="mobile-nav-item" onClick={closeMenu}>
                                        <FiUser /> Profile
                                    </NavLink>
                                    <button
                                        onClick={() => { onLogout(); closeMenu(); }}
                                        className="mobile-nav-item logout-btn"
                                    >
                                        <FiLogOut /> Logout
                                    </button>
                                </>
                            ) : (
                                <NavLink to="/login" className="mobile-nav-item signin-btn" onClick={closeMenu}>
                                    <FiUser /> Sign In
                                </NavLink>
                            )}
                        </div>
                    </nav>
                </div>
            )}

            <style>{`
                .desktop-nav {
                    display: flex;
                }

                .mobile-menu-btn {
                    display: none;
                    background: none;
                    border: none;
                    color: var(--text-main);
                    cursor: pointer;
                    padding: 0.5rem;
                }

                .nav-item {
                    font-size: 1rem !important;
                    font-weight: 600 !important;
                }

                .mobile-menu-overlay {
                    display: none;
                }

                @media (max-width: 900px) {
                    .desktop-nav {
                        display: none !important;
                    }

                    .mobile-menu-btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .mobile-menu-overlay {
                        display: block;
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(0, 0, 0, 0.7);
                        z-index: 1000;
                        animation: fadeIn 0.2s ease;
                    }

                    .mobile-menu {
                        position: fixed;
                        top: 0;
                        right: 0;
                        width: 280px;
                        height: 100vh;
                        background: var(--bg-card);
                        border-left: 1px solid var(--border);
                        padding: 1.5rem;
                        animation: slideIn 0.3s ease;
                        overflow-y: auto;
                    }

                    .mobile-menu-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 2rem;
                        padding-bottom: 1rem;
                        border-bottom: 1px solid var(--border);
                    }

                    .mobile-menu-links {
                        display: flex;
                        flex-direction: column;
                        gap: 0.5rem;
                    }

                    .mobile-nav-item {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        padding: 1rem;
                        color: var(--text-muted);
                        text-decoration: none;
                        font-size: 1.1rem;
                        font-weight: 600;
                        border-radius: 0.75rem;
                        transition: all 0.2s;
                        background: none;
                        border: none;
                        width: 100%;
                        text-align: left;
                        cursor: pointer;
                    }

                    .mobile-nav-item:hover,
                    .mobile-nav-item.active {
                        background: rgba(99, 102, 241, 0.1);
                        color: var(--primary);
                    }

                    .mobile-nav-item.logout-btn {
                        color: var(--danger);
                        margin-top: 1rem;
                    }

                    .mobile-nav-item.logout-btn:hover {
                        background: rgba(239, 68, 68, 0.1);
                    }

                    .mobile-nav-item.signin-btn {
                        background: var(--primary);
                        color: white;
                        margin-top: 1rem;
                        justify-content: center;
                    }

                    @keyframes slideIn {
                        from {
                            transform: translateX(100%);
                        }
                        to {
                            transform: translateX(0);
                        }
                    }
                }
            `}</style>
        </>
    );
};

export default Navbar;
